import { KeyCode } from '../../../keycode';
const HOME = 36;
const END = 35;
export const useMenuKeyboard = ({ goUp, goDown, selectOption, goHome, goEnd, closeDropdown, preventNativeSpace = false, }) => {
    return (event) => {
        switch (event.detail.keyCode) {
            case KeyCode.up:
                event.preventDefault();
                goUp();
                break;
            case KeyCode.down:
                event.preventDefault();
                goDown();
                break;
            case HOME:
                goHome();
                break;
            case END:
                goEnd();
                break;
            case KeyCode.escape:
                event.stopPropagation();
                closeDropdown();
                break;
            case KeyCode.enter:
                event.preventDefault();
                selectOption();
                break;
            case KeyCode.space:
                if (preventNativeSpace) {
                    event.preventDefault();
                    selectOption();
                }
        }
    };
};
export const useTriggerKeyboard = ({ openDropdown, goHome }) => {
    return (event) => {
        switch (event.detail.keyCode) {
            case KeyCode.up:
            case KeyCode.down:
                event.preventDefault();
                goHome();
                openDropdown();
                break;
            case KeyCode.space:
            case KeyCode.enter:
                event.preventDefault();
                openDropdown();
                break;
        }
    };
};
//# sourceMappingURL=use-keyboard.js.map